module.exports = __webpack_public_path__ + "static/media/banner_v8.8e125d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_v8.png
// module id = 312
// module chunks = 0